// src/services/budgetCategoryService.js
import axios from '@/api'

export default {
  getAll() {
    return axios.get('/budget-categories')
  },
  get(id) {
    return axios.get('/budget-categories').then(res => {
      return res.data.find(c => c.id == id)
    })
  },
  create(data) {
    return axios.post('/budget-categories', data)
  },
  update(id, data) {
    return axios.put(`/budget-categories/${id}`, data)
  },
  delete(id) {
    return axios.delete(`/budget-categories/${id}`)
  }
}
